import { createInstance, dateReviver } from '@/api';
import { PublicationClient, Publication } from '@/api/frontoffice/clients';
import { useAlertStore } from '@/modules/core/store/alert.store';
import { defineStore } from 'pinia';
import { i18n } from '@/i18n';

export interface PublicationDetailStoreState {
    loading: boolean;
    publication: Publication;
}

export const client = new PublicationClient('', createInstance(), dateReviver);

export const usePublicationDetailStore = defineStore('publications-publications-detail-store', {
    state: (): PublicationDetailStoreState => ({
        loading: false,
        publication: null
    }),
    getters: {},
    actions: {
        async getPublication(id: string): Promise<void> {
            this.loading = true;
            useAlertStore().clearAlert();
            try {
                const response = await client.getPublicationDetail(id);
                this.publication = response;
            } catch (error) {
                useAlertStore().handleException(i18n.global.t('publications.detail.error.title'), error, false);
            } finally {
                this.loading = false;
            }
        },
        clear() {
            this.publication = null;
            this.loading = false;
            useAlertStore().clearAlert();
        }
    }
});
